const getGroupScrollId = (contentVersion) => {
    return `content-version-${contentVersion.uuid}`;
};

export default getGroupScrollId;
